module.exports = __webpack_public_path__ + "img/edge-of-death-unknown.7700f0ef.jpg";